/**
 * Handoff Cookie — propaga empresa selecionada para novas abas.
 * Cookie short-lived (30s), SameSite=Lax, mesmo domínio.
 */

const HANDOFF_KEY = 'empresa_handoff'
const STORAGE_KEY = 'company' // mesma chave usada pelo Vuex no sessionStorage

export function getCookie (name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

export function deleteCookie (name, path = '/') {
  document.cookie = `${name}=; Max-Age=0; Path=${path}; SameSite=Lax`
}

/**
 * Seta o cookie de handoff com o valor atual da empresa.
 * Chamar antes de abrir nova aba (window.open ou link).
 * @param {string} value — valor serializado da empresa (mesmo formato do sessionStorage)
 * @param {number} maxAge — TTL em segundos (padrão: 30)
 */
export function setHandoffCookie (value, maxAge = 30) {
  document.cookie = `${HANDOFF_KEY}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`
}

/**
 * Lê o cookie de handoff, transfere para sessionStorage e deleta o cookie.
 * Chamar no boot da aplicação, antes de montar o Vue.
 * @returns {string|null} — valor transferido, ou null se não havia cookie
 */
export function consumeHandoffCookie () {
  const value = getCookie(HANDOFF_KEY)
  if (!value) return null
  sessionStorage.setItem(STORAGE_KEY, value)
  deleteCookie(HANDOFF_KEY)
  return value
}

export { HANDOFF_KEY, STORAGE_KEY }



// WEBPACK FOOTER //
// ./src/utils/handoff.js